module.exports = __webpack_public_path__ + "img/home_banner1.52200be9.png";